export const comments_3257650 = {"data":{"data":[],"links":{}}}